export default "__VITE_ASSET__D2b$U0Zi__"